export default [
    {
        name: 'Computer_Model',
        type: 'gltfModel',
        path: 'Models/Retro_Computer/scene.gltf'
    },
    {
        name: "earth",
        type: "gltfModel",
        path: "Models/earth/earth.glb"
    }
]